import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { ICellRenderer } from 'ag-grid-community';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'ac-worst-offender-badge-cell-renderer',
	templateUrl: './worst-offender-badge-cell-renderer.component.html',
	styleUrls: ['./worst-offender-badge-cell-renderer.component.scss']
})
export class WorstOffenderBadgeCellRendererComponent implements ICellRenderer {
	@InjectConfig(SharedConfigKey.ENABLE_WORST_TAX_OFFENDERS) public readonly showWorstOffenderBadge = false;

	public value: string;
	public hasWorstOffenderBadge: boolean = false;

	public agInit(params: any): void {
		if (params?.value) {
			this.value = params?.value?.formattedValue ?? '';
			this.hasWorstOffenderBadge = params?.data?.['worstOffenderFlag']?.formattedValue === 'true';
		}
	}

	public refresh(): boolean {
		return false;
	}
}
